import { geniFetch } from "@/api/geniBackend";

export interface GeniPack {
  id: string;
  label: string;
  geni: number;
  rub: number;
}

export interface BillingPayment {
  orderId: number;
  status: string;
  amount: string;
  currency: string;
  description: string;
  paidAt: string | null;
  paymentId: string | null;
  gateway: string;
  userId: string;
  createdAt: string;
  geniCount: number;
  geniAdded: boolean;
}

export interface CreatePaymentLinkResponse {
  orderId: number;
  paymentUrl: string;
  status: string;
}

const V0_GENI_PACKS: GeniPack[] = [
  { id: "free", label: "Бесплатный", geni: 15, rub: 0 },
  { id: "pack_60", label: "Старт", geni: 60, rub: 6000 },
  { id: "pack_120", label: "Студия", geni: 120, rub: 10800 },
  { id: "pack_240", label: "Бизнес", geni: 240, rub: 19200 },
];

export async function getBillingPacks(): Promise<GeniPack[]> {
  const payload = await geniFetch<{ packs: GeniPack[] }>("/billing/packs");
  const serverPackIds = new Set((payload.packs ?? []).map((pack) => pack.id));

  // Keep server availability, but force canonical v0 values for all known packs.
  const normalized = V0_GENI_PACKS.filter((pack) => serverPackIds.has(pack.id));

  if (normalized.length > 0) {
    return normalized;
  }

  // Fallback for environments where backend does not return packs yet.
  return V0_GENI_PACKS;
}

export async function getBillingBalance(): Promise<number> {
  const payload = await geniFetch<{ balance: number }>("/billing/balance");
  return payload.balance;
}

export async function createPaymentLink(tariffId: string): Promise<CreatePaymentLinkResponse> {
  return geniFetch<CreatePaymentLinkResponse>("/billing/payment-link", {
    method: "POST",
    body: JSON.stringify({ tariffId }),
  });
}

export async function getOrderStatus(orderId: number): Promise<BillingPayment> {
  return geniFetch<BillingPayment>(`/billing/payments/${orderId}/status`);
}

export async function getSuccessfulPayments(): Promise<BillingPayment[]> {
  return geniFetch<BillingPayment[]>("/billing/payments/successful");
}

export async function spendGeni(amount: number, reason: string): Promise<{ balance: number }> {
  return geniFetch<{ balance: number }>("/billing/spend", {
    method: "POST",
    body: JSON.stringify({ amount, reason }),
  });
}
